/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require("./bootstrap");

import Vue from "vue";
import Multiselect from "vue-multiselect";

import html2pdf from "html2pdf.js/dist/html2pdf.js";

import VueHtmlToPaper from "vue-html-to-paper";

const printoptions = {
    name: "_blank",
    specs: [
        "fullscreen=yes",
        // 'titlebar=yes',
        // 'scrollbars=yes'
    ],
    styles: [
        "https://kit.fontawesome.com/ad66c9c2be.js",
        "https://code.ionicframework.com/ionicons/2.0.1/css/ionicons.min.css",
        "https://fonts.googleapis.com/css?family=Source+Sans+Pro:300,400,400i,700&display=fallback",
        "https://cdn.jsdelivr.net/npm/bootstrap@3.4.1/dist/css/bootstrap.min.css",
        "https://maxcdn.bootstrapcdn.com/font-awesome/4.3.0/css/font-awesome.min.css",
        "/css/invoice.css",
        "/css/app.css",
        "/js/app.js",
    ],
};

Vue.use(VueHtmlToPaper, printoptions);

var Chart = require("chart.js");

//  import VueSplide from '@splidejs/vue-splide';

//  Vue.use( VueSplide );

import VueQRCodeComponent from "vue-qrcode-component";
Vue.component("qr-code", VueQRCodeComponent);

import VueBarcode from "vue-barcode";
Vue.component("barcode", VueBarcode);

// new Vue({
//     components: {
//         barcode: VueBarcode,
//     },
// });

import Gate from "./Gate";
Vue.prototype.$gate = new Gate(window.user);

import router from "./router.js";

Vue.component(HasError.name, HasError);
Vue.component(AlertError.name, AlertError);

import swal from "sweetalert2";
window.swal = swal;
const toast = swal.mixin({
    toast: true,
    position: "top-end",
    showConfirmButton: false,
    timer: 6000,
});
window.toast = toast;

import moment from "moment";

Vue.filter("addedDate", function (created) {
    return moment(created).format("Do MMMM YYYY");
});

Vue.filter("issueDate", function (created) {
    return moment(created).format("Do MMMM YYYY");
});

Vue.filter("yearOnly", function (created) {
    return moment(created).format("YY");
});

Vue.filter("upperCase"),
    function (value) {
        return value.toUpperCase();
    };

Vue.filter("timeStamp", function (value) {
    return moment(value).format("Do MMMM YYYY hh:mm a");
});

Vue.filter("formattedDate", function (value) {
    // var actual=moment(value).add(24, 'hours');
    // return moment.utc(actual).format('Do MMMM YYYY');
    return moment.utc(value).format("Do MMMM YYYY");
});

Vue.filter("formattedDateWithOne", function (value) {
    var actual = moment(value).add(24, "hours");
    return moment.utc(actual).format("Do MMMM YYYY");
    // return moment.utc(value).format('Do MMMM YYYY');
});

Vue.filter("smallDate", function (value) {
    return moment(value).format("DD-MM-YYYY");
});

Vue.filter("smallDateAfter7Days", function (value) {
    var expiry_date = moment(value).add(7, "days");
    return moment(expiry_date).format("Do MMMM YYYY");

    // var expiry_date = new Date(moment(value) + 7 * 24 * 60 * 60 * 1000);
    // return expiry_date.format('Do MMMM YYYY');
});

Vue.filter("date", function (created) {
    return moment.utc(created.toLocaleString()).format("Do MMMM YYYY hh:mm");
});

// System for American Numbering
var th_val = ["", "thousand", "million", "billion", "trillion"];
// System for uncomment this line for Number of English
// var th_val = ['','thousand','million', 'milliard','billion'];

var dg_val = [
    "zero",
    "one",
    "two",
    "three",
    "four",
    "five",
    "six",
    "seven",
    "eight",
    "nine",
];
var tn_val = [
    "ten",
    "eleven",
    "twelve",
    "thirteen",
    "fourteen",
    "fifteen",
    "sixteen",
    "seventeen",
    "eighteen",
    "nineteen",
];
var tw_val = [
    "twenty",
    "thirty",
    "forty",
    "fifty",
    "sixty",
    "seventy",
    "eighty",
    "ninety",
];
function toWords(s) {
    s = s.toString();
    s = s.replace(/[\, ]/g, "");
    if (s != parseFloat(s)) return "not a number ";
    var x_val = s.indexOf(".");
    if (x_val == -1) x_val = s.length;
    if (x_val > 15) return "too big";
    var n_val = s.split("");
    var str_val = "";
    var sk_val = 0;
    for (var i = 0; i < x_val; i++) {
        if ((x_val - i) % 3 == 2) {
            if (n_val[i] == "1") {
                str_val += tn_val[Number(n_val[i + 1])] + " ";
                i++;
                sk_val = 1;
            } else if (n_val[i] != 0) {
                str_val += tw_val[n_val[i] - 2] + " ";
                sk_val = 1;
            }
        } else if (n_val[i] != 0) {
            str_val += dg_val[n_val[i]] + " ";
            if ((x_val - i) % 3 == 0) str_val += "hundred ";
            sk_val = 1;
        }
        if ((x_val - i) % 3 == 1) {
            if (sk_val) str_val += th_val[(x_val - i - 1) / 3] + " ";
            sk_val = 0;
        }
    }
    // if (x_val != s.length) {
    //     var y_val = s.length;
    //     str_val += 'and ';
    //     for (var i = x_val + 1; i < y_val; i++)
    //         str_val += dg_val[n_val[i]] + ' ';
    // }
    return str_val.replace(/\s+/g, " ");
}

Vue.filter("toWords", function (value) {
    if (!value) return "";
    return toWords(value).toUpperCase();
});

Vue.filter("dotNumbers", function (value) {
    var str = Intl.NumberFormat("en-IN").format(value);
    // var str = Intl.NumberFormat('en-IN', { maximumSignificantDigits: 8 }).format(value);
    return str;
    // var str = value.toString().split(".");
    //   str[0] = str[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    //   return str.join(".");
});

//  import VueGoodTablePlugin from 'vue-good-table';

// import the styles
//  import 'vue-good-table/dist/vue-good-table.css'

//  Vue.use(VueGoodTablePlugin);

//  import EditableCell from '@lucasbiguet/vue-editable-cell'

//  Vue.use(EditableCell)

import vSelect from "vue-select";
Vue.component("v-select", vSelect);
import "vue-select/dist/vue-select.css";

//  import { saveAs } from 'file-saver';
//  var FileSaver = require('file-saver');

import { VueEditor, Quill } from "vue2-editor";

import * as VueGoogleMaps from "vue2-google-maps";

Vue.use(VueGoogleMaps, {
    load: {
        key: "AIzaSyApmh0aETNKnpnL0SrP5AqazaQLgwrstOk",
        libraries: "places",
    },
});

import { ToggleButton } from "vue-js-toggle-button";

Vue.component("ToggleButton", ToggleButton);

import { Form, HasError, AlertError } from "vform";
window.Form = Form;
Vue.component(HasError.name, HasError);
Vue.component(AlertError.name, AlertError);

if (document.querySelector("meta[name='user-id']") != null) {
    Vue.prototype.$userId = document
        .querySelector("meta[name='user-id']")
        .getAttribute("content");
    Vue.prototype.$userEmail = document
        .querySelector("meta[name='user-email']")
        .getAttribute("content");
    Vue.prototype.$fname = document
        .querySelector("meta[name='user-fname']")
        .getAttribute("content");
    Vue.prototype.$lname = document
        .querySelector("meta[name='user-lname']")
        .getAttribute("content");
    Vue.prototype.$phone = document
        .querySelector("meta[name='user-phone']")
        .getAttribute("content");
}
//Vue.prototype.$verified = document.querySelector("meta[name='user-verified']").getAttribute('content');

// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
    apiKey: "AIzaSyCO9sDgzJSnI-mIunkpXGnb0tEiAWOg-AU",
    authDomain: "o2desk.firebaseapp.com",
    projectId: "o2desk",
    storageBucket: "o2desk.appspot.com",
    messagingSenderId: "58794018159",
    appId: "1:58794018159:web:44d44737334feb3947d49a",
    measurementId: "G-LWX5HV3RDW",
};

// Initialize Firebase
const firebaseApp = initializeApp(firebaseConfig);
const firebaseAnalytics = getAnalytics(firebaseApp);

import VueProgressBar from "vue-progressbar";
Vue.use(VueProgressBar, {
    color: "rgb(143, 255, 199)",
    failedColor: "red",
    thickness: "10px",
    transition: {
        speed: "0.2s",
        opacity: "0.6s",
        termination: 300,
    },
    autoRevert: true,
    location: "top",
    inverse: false,
});

//  import { createDuration } from '@fullcalendar/core';
import { utils } from "sortablejs";

const options = {
    color: "#bffaf3",
    failedColor: "#874b4b",
    thickness: "5px",
    transition: {
        speed: "0.2s",
        opacity: "0.6s",
        termination: 300,
    },
    autoRevert: true,
    location: "left",
    inverse: false,
};

// Vue.prototype.$verified = document.querySelector("meta[name='user-verified']").getAttribute('content');

// to have access to the form and other variables everywhere
window.Form = Form;

window.Vue = require("vue");

// window.google = google;

var Promise = require("es6-promise").Promise;
require("es6-promise").polyfill();

/**
 * The following block of code may be used to automatically register your
 * Vue components. It will recursively scan this directory for the Vue
 * components and automatically register them with their "basename".
 *
 * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
 */

// const files = require.context('./', true, /\.vue$/i)
// files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key).default))

Vue.component(
    "example-component",
    require("./components/ExampleComponent.vue").default
);
Vue.component("multiselect", Multiselect);
/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

const app = new Vue({
    el: "#app",
    VueEditor,
    firebaseApp,
    firebaseAnalytics,
    html2pdf,
    Quill,
    Chart,
    VueGoogleMaps,
    router,
});
